import { DateInput, useTranslate } from 'react-admin';
import type { DateInputProps } from 'ra-ui-materialui';
import { Box, InputLabel } from '@mui/material';
import { InputHelperUnderLabel } from './InputHelperUnderLabel';

export type HelperTextPlacement = 'under-label' | 'under-input';

export const GrayDateInputWithUpperLabel = (props: DateInputProps & {
  isRequired?: boolean;
  helperTextPlacement?: HelperTextPlacement;
}) => {

  const translate = useTranslate();
  const {
    helperText,
    isRequired,
    label,
    className,
    size,
    helperTextPlacement = 'under-label',
    ...rest
  } = props;

  const underLabel = helperTextPlacement === 'under-label' ? helperText : false;
  const underInput = helperTextPlacement === 'under-input' ? helperText : false;

  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      {label !== false && (
        <InputLabel className="input-label" required={isRequired}>
          {translate(typeof label === 'string' ? label : '', { _: label })}
        </InputLabel>
      )}
      <InputHelperUnderLabel helperText={underLabel} />
      <DateInput
        {...rest}
        className={className ? `${className} bhvk-gray-input` : 'bhvk-gray-input'}
        label={false}
        helperText={underInput}
        size={size}
        InputProps={{
          ...props.InputProps,
          notched: false,
        }}
        sx={[
          {
            mt: 0,
            mb: 0,
            '& .MuiOutlinedInput-root': {
              boxSizing: 'border-box',
              height: props.size === 'small' ? 40 : 56,
              alignItems: 'center',
            },
          },
          ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        ]}
        InputLabelProps={{
          ...props.InputLabelProps,
          shrink: true,
        }}
      />
    </Box>
  );

};
